export default __webpack_public_path__ + "event-summary.png";